export function FixedScrollDirective($window) {
  return {
    scope: {},
    link: function (scope, elem, attrs) {
      $($window).on('scroll', function (e) {
        if (elem.scrollTop() > 100) {
          elem.addClass('fixed-header');
        } else {
          elem.removeClass('fixed-header');
        }
      });
    },
  };
}

FixedScrollDirective.$inject = ['$window'];
